import script from "./DashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardView.vue?vue&type=script&setup=true&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=5d4a3885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4a3885"]])

export default __exports__